import Axios from '@/axios';

// 查询枚举列表
export const getEnums = params => {  
  return Axios({
    url: '/face/web/common/show_enums',
    method: 'GET',
    type: 'json',
    params
  })
}
// 显示请求者所在城市的天气信息
export const getWeather = params => {  
  return Axios({
    url: '/face/web/common/show_weather',
    method: 'GET',
    type: 'json',
    params
  })
}